import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/[lng]/not-found.tsx");
